import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { Logo } from '../../ui-kit/Logo/Logo.js';
import { SearchBar } from '../../ui-kit/SearchBar/SearchBar.js';
import { LEFT_COLUMN_STYLE } from './leftColumnStyle.js';
export const renderLogoSearchBar = (common, navigationItems) => {
    const { logo } = common ?? {};
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { dataHeader, dataFooter, ...logoProps } = logo ?? {};
    return (_jsxs("div", { className: "flex items-stretch gap-3xl", children: [_jsx(Logo, { className: LEFT_COLUMN_STYLE, logo: logoProps, data: dataFooter, showTitle: false }), _jsx(SearchBar, { className: "grow", navigationItems: navigationItems, ...common })] }));
};
//# sourceMappingURL=renderLogoSearchBar.js.map